import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "reduxStore";
import { getLearningTasksAction } from "slices/learningTasks";
import FlexItem from "./shared/layout/FlexItem";
import FlexContainer from "./shared/layout/FlexContainer";
import { H1, H2, H3 } from "./shared/primitives/Heading";
import Paragraph from "./shared/primitives/Paragraph";
import { useParams } from "react-router-dom";
import LearningTaskAnswerVersion from "./LearningTaskAnswerVersion";
import { selectLearningTask } from "selectors/learningTask";
import { learningTaskAnswerVersionStatusPhrases, learningTaskAnswerVersionStatusTranslations, } from "./helpers/translations";
import { formatDate } from "./helpers/dateFormatting";
import Icon from "./shared/primitives/Icon";
import { style } from "config";
import styled from "styled-components";
import Markdown from "react-markdown";
import { OrderedMarkdownList, UnorderedMarkdownList } from "./shared/primitives/List";
import { NewTabLink } from "./shared/primitives/Link";
const TeaserContainer = styled.div `
  max-width: 800px;
`;
export default function LearningTask() {
    const dispatch = useAppDispatch();
    const { learningTaskId, learningCategoryId } = useParams();
    const learningTask = useSelector(selectLearningTask(learningTaskId));
    const getLearningTasks = () => {
        if (learningCategoryId) {
            dispatch(getLearningTasksAction(learningCategoryId));
        }
    };
    useEffect(() => {
        if (!learningTask) {
            getLearningTasks();
        }
    }, [learningTask]);
    if (!learningTask)
        return null;
    const { title, text, teasers, attachments, answer } = learningTask;
    const latestVersion = answer === null || answer === void 0 ? void 0 : answer.versions[0];
    const formatFileSize = (bytes) => {
        if (bytes === 0)
            return "0 Bytes";
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    };
    return (React.createElement(FlexContainer, { fullWidth: true, flexDirection: "column" },
        React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(H1, { solo: true, color: "primary" }, title)),
        teasers && teasers.length > 0 && (React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(FlexContainer, { flexDirection: "column", gap: "1rem", padding: "0 1rem", alignItems: "center" }, teasers.map((teaser) => (React.createElement(TeaserContainer, { key: teaser.id },
                teaser.contentType.startsWith("image/") && (React.createElement("img", { src: teaser.url, alt: teaser.filename, style: { maxWidth: "100%", borderRadius: "4px" } })),
                teaser.contentType.startsWith("video/") && (React.createElement("video", { src: teaser.url, controls: true, style: { maxWidth: "100%", borderRadius: "4px" } })))))))),
        React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(Markdown, { components: { a: NewTabLink, p: Paragraph, ul: UnorderedMarkdownList, ol: OrderedMarkdownList } }, text),
            attachments && attachments.length > 0 && (React.createElement(FlexContainer, { flexDirection: "column", gap: "0.5rem", padding: "1rem 0", alignItems: "flex-start" },
                React.createElement(H3, null, "Aufgabendateien:"),
                attachments.map((attachment) => (React.createElement(FlexContainer, { key: attachment.id, alignItems: "center", gap: "0.5rem" },
                    React.createElement("a", { href: attachment.url, target: "_blank", rel: "noopener noreferrer" }, attachment.filename),
                    React.createElement("span", null,
                        "(",
                        formatFileSize(attachment.byteSize),
                        ")"))))))),
        (!latestVersion || latestVersion.status == "improvement_requested") && (React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(H2, null, `Antwort ${latestVersion ? latestVersion.versionNumber + 1 : 1}`),
            React.createElement(LearningTaskAnswerVersion, { taskId: learningTask.id, answerId: answer === null || answer === void 0 ? void 0 : answer.id }))), answer === null || answer === void 0 ? void 0 :
        answer.versions.map((v) => (React.createElement(FlexItem, { key: v.id, column: 1 / 1 },
            React.createElement(H2, null,
                `Antwort ${v.versionNumber} - ${learningTaskAnswerVersionStatusTranslations[v.status]}`,
                v.status === "accepted" && (React.createElement(Icon, { color: "green", icon: "checkboxChecked", margin: "0 0 0 0.5rem", width: "1.5rem", height: "1.5rem" })),
                v.status === "submitted" && (React.createElement("span", { style: { display: "block", fontSize: "1rem", lineHeight: "1.5rem", color: style.colors.darkGray } }, `${learningTaskAnswerVersionStatusPhrases.submitted}. Wir melden uns in Kürze bei Dir!`)),
                React.createElement("span", { style: { display: "block", fontSize: "0.8rem", lineHeight: "1.5rem", color: style.colors.fontGrayDark } }, formatDate(v.updatedAt))),
            React.createElement(LearningTaskAnswerVersion, { version: v, taskId: learningTask.id, answerId: answer.id }))))));
}
